module.exports = __webpack_public_path__ + "img/scroll-bg-3.bbd927bb.png";